// Contract upgrade flags - isolated to prevent circular dependencies

// Set to true during Ethereum contract upgrades
// This will show an upgrade banner and disable withdrawals
export const IS_CONTRACT_UPGRADE_IN_PROGRESS = false;
